<template>
  <nav class="navbar navbar-expand-lg navbar-light d-flex flex-column bg-light px-0 shop-nav">
    <div class="row w-100 d-flex justify-content-between">
      <div class="col-12 col-md-6 col-lg-3">
        <ShopFilter
          :class="{disabled:$page.props.custom}"
          :categories="categories" 
          :categoryRoute="categoryRoute"
          @category="category"
        />
      </div>
      <div class="col-12 col-md-6 col-lg-3 mt-2 mt-md-0">
        <ManufacturerFilter
          :class="{disabled:$page.props.custom}"
          :manufacturer_id="Number($page.props.manufacturer_id)"
          :shopRoute="shopRoute" 
          :categoryRoute="categoryRoute"
        />
      </div>
      <NavShopButtons 
        v-if="shopButtons && !(isUserHasToolFair2023() && queryHas('tool-fair-2023'))"
        :class="{disabled: $page.props.custom}"
        :categoryRoute="categoryRoute"
      />
      <div v-else class="col d-none d-lg-block"></div>
      <div class="col-12 col-md-6 col-lg-3 d-flex justify-content-end mt-0 mt-md-2 mt-lg-0">
        <SearchBar 
          :categoryRoute="categoryRoute"
          :shopRoute="shopRoute"
        />
      </div>
      <div class="col-12 mt-2" v-if="showDownloadProducts">
        <jet-button
          class="btn btn-primary float-right"
          btnStyle="success"
          @click="downloadProducts"
          :disable="downloadProductsLoading"
          ><i class="fa fa-download"></i> Download All Products</jet-button
        >
      </div>
    </div>

  </nav>
</template>

<script>
  import SearchBar from '@/Shared/SearchBar'
  import ShopFilter from '@/Components/Nav/ShopFilter'
  import ManufacturerFilter from '@/Components/Nav/ManufacturerFilter'
  import NavShopButtons from '@/Components/Nav/ShopButtons'
  import CategoryBar from '@/Components/Nav/CategoryBar'

  export default {
    components: {
      SearchBar,
      ShopFilter,
      ManufacturerFilter,
      NavShopButtons,
      CategoryBar
    },
    props: {
      categories: Array,
      categoryRoute: String,
      shopRoute: String,
      searchText: String,
      shopButtons: {
        type: Boolean,
        default: true
      },
      downloadProductsLoading: {
        type: Boolean,
        default: false
      },
      showDownloadProducts: {
        type: Boolean,
        default: false
      }
    },
    mounted() {
    },
    methods: {
      downloadProducts() {
        this.$emit('downloadProducts')
      },
      category(cat) {
        this.$emit('category', cat)
      }
    }
  }
</script>
